export enum TeamMemberRole {
    Admin = 'Admin',
    Guest = 'Guest',
    Shadow = 'Shadow',
    Undefined = 'Undefined',
    User = 'User',
    Test = "Test"
}

export enum TeamMemberType {
    Bot = "BOT",
    ADUser = "ADUser"
}
